import { response } from "app/helpers/commonInterface";
import {
  GET_ALL_CLIENT_LIST_FAILURE,
  GET_ALL_CLIENT_LIST_REQUEST,
  GET_ALL_CLIENT_LIST_SUCCESS,
  GET_CLIENT_LIST_FAILURE,
  GET_CLIENT_LIST_REQUEST,
  GET_CLIENT_LIST_SUCCESS,
  UPDATE_CLIENT_STATUS_SUCCESS,
} from "../actionTypes";
import { updateStatusFun } from "../stateHelperFunction";
import { client } from "./clientDataInterfce";
export interface allClientListState {
  loading: boolean;
  clientList: response<client[]>;
  error: string;
}

interface action {
  type: string;
  payload: any;
}

const initialState: allClientListState = {
  loading: false,
  clientList: {},
  error: "",
};

export const allClientListReducer = (state = initialState, action: action) => {
  switch (action.type) {
    case GET_ALL_CLIENT_LIST_REQUEST:
      return {
        loading: true,
      };
    case GET_ALL_CLIENT_LIST_SUCCESS:
      return {
        loading: false,
        clientList: action.payload,
        error: "",
      };
    case GET_ALL_CLIENT_LIST_FAILURE:
      return {
        loading: false,
        clientList: {},
        error: action.payload,
      };
    default:
      return state;
  }
};
